import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'replaceIfEmptyOrNullOrUndefined' })
export class ReplaceIfEmptyOrNullOrUndefined implements PipeTransform {
	public transform(value: string, replaceValue = ''): string {
		return value ? value : replaceValue;
	}
}
